import * as ActionTypes from '../action-types'

const driverPretripChecklists_DefaultState = {
    byID: {},
    byIDMalay: {},
    byCategory: {},
    advancedFilters: {},
    allIDs: []
}

export const driverPretripChecklists = (state = driverPretripChecklists_DefaultState, action) => {

    let newState = JSON.parse(JSON.stringify(state))

    if(!action) return newState

    switch (action.type) {
        case ActionTypes.GET_ALL_DRIVER_PRETRIP_CHECKLIST: {
            const driverChecklistItems = action.driverChecklistItems

            driverChecklistItems
            &&
            driverChecklistItems.length
            &&
            driverChecklistItems.map(checklist => {
                const { category, itemid } = checklist

                newState.byID[itemid] = checklist

                if(!newState.byCategory[category]) {
                    newState.byCategory[category] = []
                }

                if(!(newState.byCategory[category] || [])?.includes(itemid)) {
                    newState.byCategory[category]?.push(itemid)
                }
                
                if(!(newState.allIDs)?.includes(itemid)) {
                    newState.allIDs?.push(itemid)
                }

                return -1;
            })

            return newState
        }
        case ActionTypes.SET_DRIVER_PRETRIP_FILTER: {
            const filters = action.filters

            newState.advancedFilters = filters

            return newState
        }
        default:
            return newState
    }
}